import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { ads } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/ads";

export const Route = createFileRoute("/integracje/ads")({
  head: () =>
    buildSeoMeta({
      title: "Kampanie Google Ads i Facebook Ads dla e-commerce | SyncTech",
      description:
        "Prowadzenie kampanii Facebook Ads, Instagram Ads, Google Ads (Performance Max, Shopping, Search). Konfiguracja Pixel + Conversions API, lejki sprzedażowe, skalowanie ROAS.",
      path: PATH,
    }),
  component: () => <PlatformPage data={ads} path={PATH} breadcrumbCategory="Integracje" />,
});
